import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl, userName, ipAddress } from "./Univ.js";

function AddBoothTurnout() {
  const [booths, setBooths] = useState([]);
  const [rows, setRows] = useState([]);

  const [form, setForm] = useState({
    booth: "",
    hour: "",
    male_voted: "",
    female_voted: "",
    third_voted: "",
    reported_by: "",
  });

  // ---------- FETCH BOOTHS ----------
  useEffect(() => {
    axios.get(baseUrl + "booths/").then((r) => setBooths(r.data));
  }, []);

  // ---------- FETCH TURNOUT ----------
  const fetchTurnout = () => {
    axios
      .get(baseUrl + "turnout/")
      .then((r) => setRows(r.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    fetchTurnout();
  }, []);

  // ---------- HANDLE CHANGE ----------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  // ---------- SUBMIT ----------
  const submit = () => {
    if (!form.booth || !form.hour) {
      Swal.fire("Error", "Booth and Hour are required", "error");
      return;
    }

    const payload = {
      ...form,
      addedby: userName,
      ip_add: ipAddress,
    };

    axios
      .post(baseUrl + "turnout/", payload)
      .then(() => {
        Swal.fire("Saved", "Turnout updated", "success");
        setTimeout(() => window.location.reload(), 1000);

        setForm({
          booth: "",
          hour: "",
          male_voted: "",
          female_voted: "",
          third_voted: "",
          reported_by: "",
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to save turnout", "error");
      });
  };

  // ---------- DELETE ----------
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This record will be permanently deleted",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + "delete-turnout/" + id + "/").then(() => {
          Swal.fire("Deleted", "Turnout removed", "success");
          fetchTurnout();
        });
      }
    });
  };

  // ---------- DATAGRID COLUMNS ----------
  const columns = [
    { field: "id", headerName: "ID", width: 70 },

    {
      field: "booth",
      headerName: "Booth",
      width: 120,
      renderCell: (params) =>
        `Booth ${params.value?.booth_number || params.value}`,
    },

    { field: "hour", headerName: "Hour", width: 90 },
    { field: "male_voted", headerName: "Male", width: 100 },
    { field: "female_voted", headerName: "Female", width: 110 },
    { field: "third_voted", headerName: "Third", width: 100 },
    { field: "addedby", headerName: "Reported By", width: 150 },

    {
      field: "actions",
      headerName: "Actions",
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <button
          className="btn btn-sm btn-danger"
          onClick={() => handleDelete(params.id)}
        >
          Delete
        </button>
      ),
    },
  ];

  return (
    <section className="container mt-4">
      {/* -------- FORM CARD -------- */}
      <div className="card">
        <h4 className="card-header">Booth Turnout (Hourly)</h4>

        <div className="card-body">
          <select
            className="form-control mb-3"
            name="booth"
            value={form.booth}
            onChange={handleChange}
          >
            <option value="">-- Select Booth --</option>
            {booths.map((b) => (
              <option key={b.id} value={b.id}>
                Booth {b.booth_number}
              </option>
            ))}
          </select>

          <input
            type="number"
            className="form-control mb-3"
            name="hour"
            placeholder="Hour (7 - 17)"
            value={form.hour}
            onChange={handleChange}
          />

          <input
            type="number"
            className="form-control mb-3"
            name="male_voted"
            placeholder="Male Voted"
            value={form.male_voted}
            onChange={handleChange}
          />

          <input
            type="number"
            className="form-control mb-3"
            name="female_voted"
            placeholder="Female Voted"
            value={form.female_voted}
            onChange={handleChange}
          />

          <input
            type="number"
            className="form-control mb-3"
            name="third_voted"
            placeholder="Third Gender Voted"
            value={form.third_voted}
            onChange={handleChange}
          />

          <input
            className="form-control mb-3"
            name="reported_by"
            placeholder="Reported By"
            value={form.reported_by}
            onChange={handleChange}
          />

          <button className="btn btn-primary" onClick={submit}>
            Save Turnout
          </button>
        </div>
      </div>

      {/* -------- DATAGRID -------- */}
      <div className="mt-4">
        <DataGrid
          rows={rows}
          columns={columns}
          autoHeight
          pageSize={25}
          rowsPerPageOptions={[25, 50, 100]}
          components={{ Toolbar: GridToolbar }}
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
          }}
        />
      </div>
    </section>
  );
}

export default AddBoothTurnout;
